import axios from "axios";

const baseURL = "https://ecart.mgmebuild.com/api/";

// Public (no token)
export const publicAxios = axios.create({
  baseURL
});

// Private (with token)
export const privateAxios = axios.create({
  baseURL
});

privateAxios.interceptors.request.use((config) => {
  const token = JSON.parse(localStorage.getItem("authTokens"))?.access;

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default publicAxios;
